import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ScheduleJobAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'schedulejob';
}

export default new ScheduleJobAPI();
